export type APIEndpointsType = {
  SIMULATION: string;
  LEARNING: string;
  BROWSER: string;
};

export const APIEndpoints: APIEndpointsType = {
  SIMULATION: import.meta.env.VITE_APP_ENDPOINT_SIMULATION,
  LEARNING: import.meta.env.VITE_APP_ENDPOINT_LEARNING,
  BROWSER: import.meta.env.VITE_APP_BROWSER_DEFENDER_HOST,
};
